// World 2 (Ember) — all levels generated.
// Spec: docs/difficulty.md §5, world 2 profile (depth 5-12, branching 2-4,
// deception 0.1-0.3, insight 0-1). Current pack uses override profile with
// wider branching; see tools/generate-world2.mjs.
import type { LevelDef } from '@tessera/engine';
import { WORLD_2_GENERATED } from './world2-generated';

export const WORLD_2_LEVELS: LevelDef[] = [...WORLD_2_GENERATED];
